const countryLabel = document.querySelector('label.country');
const countryCustomSelect = countryLabel.querySelector('.customSelect');
const countrySelectButton = countryCustomSelect.querySelector('.selectButton');
const countrySelectedValue = countryCustomSelect.querySelector('.selectedValue');
const countryPhoneInput = countryLabel.querySelector('.phone');
const countriesList = countryLabel.querySelector('.countries');
const countrySearchInput = countryLabel.querySelector('.countrySearch');

let numberOfCountriesDisplayed = 0;

function parseTwemoji(element) {
  if (typeof twemoji !== 'undefined') {
    twemoji.parse(element, { className: 'twemoji-flag' });
  }
}

const performSearchDebounced = debounce((searchTerm) => {
  const searchedCountries = countries.filter((country) =>
    country.name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  renderCountries(searchedCountries);
}, 500);

countrySelectButton.addEventListener('click', () => {
  countryLabel.classList.toggle('active');
  countrySelectButton.setAttribute(
    'aria-expanded',
    countrySelectButton.getAttribute('aria-expanded') === 'true' ? 'false' : 'true'
  );
  if (countryLabel.classList.contains('active')) {
    countrySearchInput.value = '';
    renderCountries(countries);
  }
});

countryPhoneInput.addEventListener('input', function () {
  this.value = this.value.replace(/[^0-9]/g, '');
});

countrySearchInput.addEventListener('keyup', () => {
  performSearchDebounced(countrySearchInput.value);
});

document.addEventListener('DOMContentLoaded', () => {
  parseTwemoji(countrySelectedValue.querySelector('.flag'));
  renderCountries(countries);
});

function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

function renderCountries(countries) {
  if (numberOfCountriesDisplayed === countries.length) return;

  numberOfCountriesDisplayed = countries.length;
  countriesList.innerHTML = '';

  countries.forEach((country) => {
    const listItem = document.createElement('li');
    listItem.setAttribute('role', 'option');

    listItem.innerHTML = `
      <input type="radio" id="${country.code}" name="country">
      <label for="${country.code}" class="countryFlagWithCode">
      <span class="flag twemoji-flag">${country.flag}</span>
      <span class="countryCode">${country.name}</span>
      </label>
    `;

    countriesList.appendChild(listItem);

    parseTwemoji(listItem.querySelector('.flag'));
  });

  countriesList.querySelectorAll('li').forEach((option) => {
    function handler(e) {
      if (e.type === 'click' && e.clientX !== 0 && e.clientY !== 0) {
        const countryCode = this.querySelector('label').getAttribute('for');
        const selectedCountry = countries.find((country) => country.code === countryCode);

        if (selectedCountry) {
          const flagElement = countrySelectedValue.querySelector('.flag');
          flagElement.textContent = selectedCountry.flag;
          flagElement.className = 'flag twemoji-flag';

          parseTwemoji(flagElement);
          countrySelectedValue.querySelector('.countryCode').textContent = selectedCountry.phone.code;
          countryLabel.classList.remove('active');
        }
      }
    }

    option.addEventListener('click', handler);
  });
}
